import RS from '~/api';
import { KEY_SESSION_STORAGE } from '~/constants';
import { saveToSessionStorage } from '~/helpers/storage';

const PUBLIC_KEY_NAME = 'key';
const ENCRYPTION_ENABLE = 'isEncryptEnable';

const rsaPublicKey = () => {
  // Get actual key from webService
  return RS.publicKey.get().then(({ payload }) => {
    const publicKey = payload && payload.length ? payload[0].key : null;
    const isEnable = payload && payload.length ? payload[0].enabled : false;
    saveToSessionStorage(KEY_SESSION_STORAGE, ENCRYPTION_ENABLE, isEnable);
    saveToSessionStorage(KEY_SESSION_STORAGE, PUBLIC_KEY_NAME, publicKey);

    return Promise.resolve();
  });
};

export { rsaPublicKey };
